export default {
  'aiSkills.form.packageName': 'Nombre del paquete',
  'aiSkills.form.packageName.pattern':
    'Solo letras minúsculas, números y guiones. Sin guiones al inicio/final ni consecutivos.',
  'aiSkills.form.compatibility': 'Compatibilidad',
  'aiSkills.form.instructions': 'Instrucciones',
  'aiSkills.form.instructions.edit': 'Editar Instrucciones',
  'aiSkills.form.instructions.placeholder.expanded':
    'Escriba las instrucciones detalladas para este skill...',
  'aiSkills.form.allowedTools': 'Herramientas permitidas',
  'aiSkills.form.group': 'Grupo',
  'aiSkills.form.scripts': 'Scripts',
  'aiSkills.form.references': 'Referencias',
  'aiSkills.form.assets': 'Recursos',
  'aiSkills.form.isManaged': 'Es gestionado',
  'aiSkills.form.published': 'Publicado',
  'aiSkills.form.publisher': 'Publicado por',
  'aiSkills.form.publishedDate': 'Fecha de publicación',
  'aiSkills.form.sourceProvider': 'Proveedor de Origen',
  'aiSkills.form.zipContent': 'Archivo ZIP',
  'aiSkills.form.githubTreeUrl': 'URL del árbol GitHub',
  'aiSkills.status.published': 'Publicado',
  'aiSkills.status.unpublished': 'No publicado',
  'aiSkills.sourceProvider.manual': 'Manual',
  'aiSkills.sourceProvider.git': 'Git',
  'aiSkills.sourceProvider.zip': 'Zip',
  'aiSkills.import.title': 'Importar',
  'aiSkills.import.preview': 'Vista previa',
  'aiSkills.import.preview.owner': 'Propietario',
  'aiSkills.import.preview.license': 'Licencia',
  'aiSkills.import.dragOrClick': 'Arrastra y suelta o haz clic para reemplazar',
  'aiSkills.import.selectZip': 'Selecciona un archivo ZIP',
};
